import { cloneElement, useRef, type ReactElement } from "react";
import { useLocation } from "react-router-dom";
import { useTeamWorkspaceSession } from "@/stores/use-team-workspace-session";

/** A bookmark redirects without replacing the previous clinical destination. */
export function PreserveWorkspaceReturn({ children }: { children: ReactElement<{ state?: unknown }> }) {
  const location = useLocation();
  const { returnTo } = useTeamWorkspaceSession();
  const state = useRef({ workspaceRedirect: {
    from: location.pathname + location.search + location.hash,
    returnTo,
  } });
  return cloneElement(children, { state: state.current });
}
